const shots = [
  {
    caption: '首页推荐',
    desc: '精选片单，打开就想追',
    src: '/images/guazi-screen-1.png',
  },
  {
    caption: '播放页面',
    desc: '高清流畅，沉浸观看',
    src: '/images/guazi-screen-2.jpg',
  },
  {
    caption: '收藏功能',
    desc: '一键收藏，追剧不迷路',
    src: '/images/guazi-screen-3.png',
  },
  {
    caption: '个人中心',
    desc: '记录同步，一目了然',
    src: '/images/guazi-screen-4.jpg',
  },
  {
    caption: '投屏功能',
    desc: '一键投屏，大屏更过瘾',
    src: '/images/guazi-screen-5.jpg',
  },
];

export default function GuaziScreenshots() {
  return (
    <section id="screenshots" className="guazi-anchor w-full bg-background-50 pt-20 md:pt-28 pb-16 md:pb-24 px-4 md:px-6">
      <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs md:text-sm font-bold">
          <i className="ri-smartphone-line text-base" />
          软件截图
        </span>
        <h2 className="mt-4 font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">
          瓜子影视界面一览
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-7">
          简洁清爽的操作界面，从找片到播放，每一步都顺手。
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 items-start">
        {shots.map((shot) => (
          <div key={shot.caption} className="flex flex-col items-center">
            <div className="w-full max-w-[220px] md:max-w-[240px] rounded-[26px] border-[5px] border-foreground-900 bg-foreground-950 overflow-hidden">
              <img
                src={shot.src}
                alt={`瓜子影视${shot.caption}界面截图`}
                title={`瓜子影视${shot.caption}`}
                className="w-full h-auto block"
              />
            </div>
            <h3 className="mt-4 font-heading font-bold text-base md:text-lg text-foreground-950">{shot.caption}</h3>
            <p className="mt-1 text-xs md:text-sm text-foreground-500 text-center">{shot.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}